// extracted by mini-css-extract-plugin
module.exports = {"domaindetail":"DomainDetail_domaindetail__DbXDZ"};